import { computed } from 'vue'
import htmlUtil from '@/utilities/html'

export default function(solution: Solution) {
  /**
   * submit ボタン直上にレンダリングするプライバシーポリシーキャプション
   *
   * @description
   *  Macau から入稿されたサービス固有のプライバシーポリシーがある場合のみ表示する
   *  その際には、URLがあればリンクにして表示する
   *  入稿がない場合は空文字を返し、caption には何も描画しない
   *  （情報提供への同意文言はデフォルトとして常時表示する専用セクションが担い、ここでは扱わない）
   * @returns { string } submit ボタン直上にレンダリングするプライバシーポリシーキャプション用の HTML 文字列（v-html レンダリング想定）
   */
  const privacyPolicyCaption = computed<string>(() => {
    if (!solution.privacyPolicy) return ''

    return htmlUtil.toAnchorFromUrlText(solution.privacyPolicy, '<i class="i-window__blank"></i>', ['a'])
  })

  return {
    // computed
    privacyPolicyCaption,
  }
}
